import type { ShopperBasketsTypes } from 'commerce-sdk-isomorphic'

// SFCC engraving option values: '1' no engraving, '2' member price, '3' guest price.
export const engravingOptionItem = (
  engravingText: string | undefined,
  isLoggedIn: boolean,
): ShopperBasketsTypes.OptionItem => ({
  optionId: 'engraving',
  optionValueId: engravingText ? (isLoggedIn ? '2' : '3') : '1',
})

export const withEngravingOption = (
  optionItems: ShopperBasketsTypes.OptionItem[] | undefined,
  engravingText: string,
  isLoggedIn: boolean,
): ShopperBasketsTypes.OptionItem[] => [
  ...(optionItems ?? [])
    .filter(({ optionId }) => optionId !== 'engraving')
    .map(({ optionId, optionValueId }) => ({ optionId, optionValueId })),
  engravingOptionItem(engravingText, isLoggedIn),
]
